import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type HorizontalNavQueue from './ui/HorizontalNavQueue.tsx';

export const LazyHorizontalNavQueueExperiment = lazyForPaint<typeof HorizontalNavQueue>(
	() =>
		import(
			/* webpackChunkName: "async-horizontal-nav-queue-experiment" */ './ui/HorizontalNavQueue'
		).then((HorizontalNavQueue) => HorizontalNavQueue),
	{ includeInShellOnlySsrBundle: true },
);
